













import Vue from 'vue'
import Item2ColEl from '@/components/elements/Item2ColEl.vue'
import { Item2ColIconElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'Item2ColIconEl',

  components: { Item2ColEl },

  props: {
    templateItemData: {
      type: Object as () => Item2ColIconElInterface,
      required: true
    }
  }
})
